import React from 'react';
import { Route, Switch } from "react-router-dom";
import TransferList from "./transfer-list/transfer-list";

const Transfers = () => {
  return (
    <Switch>
      <Route exact path="/transfers">
        <TransferList />
      </Route>
    </Switch>
  )
}

export default Transfers;
